"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

import { initializeClientTrace } from "@lattice/frontend/lib/observability/client-trace";

export function ClientTraceInitializer({
  appEnvironment,
}: {
  appEnvironment: string;
}) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();

  // eslint-disable-next-line no-restricted-syntax -- Faro is an external browser telemetry lifecycle boundary.
  useEffect(() => {
    void initializeClientTrace({
      appEnvironment,
      search: search ? `?${search}` : "",
    });
  }, [appEnvironment, pathname, search]);

  return null;
}
